import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  open(event) {
    if (!event.target.checked) return;

    if (kModal.$ModalOverlay) {
      kModal.remove();
    }

    fetch(this.urlValue, {
      headers: {
        "Kolide-Modal": "true",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (!response.ok) return;
        return response.text();
      })
      .then((html) => {
        if (!html) return;
        kModal.init({
          content: html,
          launchingUrl: "",
          ujs: true,
          autoClose: true,
          appendTo: document.body,
        });
      });
  }
}
